module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-area"
  }, [_c('header-bar', {
    attrs: {
      "process": "signup"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "item-selection"
  }, [_c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.chunkArray), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row), function(item, key) {
      return _c('picker-item', {
        key: key,
        attrs: {
          "itemclass": "focus-areas",
          "itemid": item['.key'],
          "itemname": item.name,
          "itemimg": item.img
        }
      })
    }))
  }))]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Learn about reputation")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.progress($event)
      }
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('div', {
    staticClass: "item-added-holder"
  }, [_c('slider', {
    attrs: {
      "data": _vm.selectedItemTags,
      "items": _vm.noOfItems
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Choose up to "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("five")]), _vm._v(" focus areas you currently work or have expertise in.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24117fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-5.vue
// module id = 689
// module chunks = 1